import {
  Box,
  Button,
  Divider,
  Grid,
  IconButton,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Field, Form, Formik } from "formik";
import { Clear } from "@mui/icons-material";

import { color } from "../../../StyleData/Config";
import { axiosPrivate } from "../../../axios/axios";
import { masterAPI } from "../dataConfig";

const SystemModal = ({ mode, handleCloseClick, editData }) => {
  const [loading, setLoading] = useState(false);
  const [parentSystem, setParentSystem] = useState([]);

  useEffect(() => {
    getParentSystemData();
  }, []);

  const getParentSystemData = async () => {
    const link = masterAPI["system"].link;
    try {
      const res = await axiosPrivate.get(`${link}`);
      setParentSystem(res.data.result);
    } catch (e) {
      setParentSystem([]);
      console.log(e, "system");
    }
  };

  const initialValue = {
    systemCode: mode === "Edit" ? editData.systemCode : "",
    systemName: mode === "Edit" ? editData.systemName : "",
    description: mode === "Edit" ? editData.description : "",
    parentSystemId: mode === "Edit" ? editData.parentSystemId : null,
  };

  const onSubmit = async (value) => {
    setLoading(true);
    const createLink = masterAPI["system"].create;
    const updateLink = masterAPI["system"].update;
    try {
      if (mode === "Create") {
        const res = await axiosPrivate.post(`${createLink}`, value);
        console.log(res.data);
      } else {
        const updateAC = { id: editData.id, ...value };
        const res = await axiosPrivate.put(`${updateLink}`, updateAC);
        console.log(res.data);
      }
      handleCloseClick();
    } catch (e) {
      console.log(e, mode === "Create" ? "createSystem" : "updateSystem");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    handleCloseClick();
  };

  return (
    <Box sx={{ p: color.masterPageDialogPadding }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <Typography
          sx={{
            color: color.masterDialogTitleColor,
            fontSize: color.masterDialogFontSize,
          }}
        >
          {mode === "Edit" ? editData.systemCode + "-" + editData.systemName : "New System"}
        </Typography>
        <IconButton onClick={handleCancel}>
          <Clear />
        </IconButton>
      </Box>
      <Divider sx={{ border: "1px solid rgb(0 0 0 / 17%)", mb: "15px" }} />
      <Formik initialValues={initialValue} onSubmit={onSubmit}>
        {({ values }) => (
          <Form>
            <Grid container spacing={"1rem"}>
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  System Code
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="text"
                  name="systemCode"
                  placeholder="Enter System Code"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      "&::placeholder": {
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  System Name
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="text"
                  name="systemName"
                  placeholder="Enter System Name"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      "&::placeholder": {
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Parent System
                </Typography>
                <Field
                  as={Select}
                  size={"small"}
                  type="text"
                  name="parentSystemId"
                  fullWidth
                  displayEmpty
                  MenuProps={{ PaperProps: { sx: { maxHeight: "40vh" } } }}
                  renderValue={
                    values.parentSystemId !== null
                      ? undefined
                      : () => (
                          <Typography
                            sx={{
                              color: color.placeholderColor,
                              fontSize: "13px",
                            }}
                          >
                            Select
                          </Typography>
                        )
                  }
                >
                  {parentSystem.map((id, i) => (
                    <MenuItem
                      key={i}
                      value={id.id}
                      disabled={editData.id === id.id && mode === "Edit"}
                    >
                      {id.systemCode + " - " + id.systemName}
                    </MenuItem>
                  ))}
                </Field>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Description
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="text"
                  name="description"
                  placeholder="Enter Description"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      "&::placeholder": {
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
              </Grid>

              <Grid
                container
                item
                xs={12}
                justifyContent={"flex-end"}
                gap="1rem"
              >
                <Button
                  onClick={handleCancel}
                  variant="contained"
                  sx={{
                    backgroundColor: color.TableCancelButton,
                    textTransform: "none",
                    color: color.CancelTextColor,
                    ":hover": {
                      backgroundColor: color.TableCancelButton,
                      textTransform: "none",
                      color: color.CancelTextColor,
                    },
                  }}
                >
                  Cancel
                </Button>
                <Button
                  type={"submit"}
                  variant="contained"
                  disabled={loading}
                  sx={{
                    textTransform: "none",
                    backgroundColor: loading ? "default" : color.TableButtonColor,
                    "&:hover": {
                      backgroundColor: loading ? "default" : color.buttonDisable,
                    },
                  }}
                >
                  Submit
                </Button>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default SystemModal;
